import { ErrorHandler, Injectable } from "@angular/core";
import { HttpErrorResponse } from '@angular/common/http';
import { TranslateService } from "@ngx-translate/core";
import { MessageService } from "primeng/api";
import { LogService } from "./log.service";

@Injectable()
export class AppErrorHandler extends ErrorHandler {
  constructor(
    private translate: TranslateService,
    private messageService: MessageService,
    private log: LogService,
  ) {
    super();
  }

  handleError(error: Error | HttpErrorResponse) {
    if(error && (error as any).handled) {
      return super.handleError(error);
    }
    if(error){
      // prevent duplicate error
      (error as any).handled = true;
      const cError = error as any;
      if(cError.error && cError.error.type === 'abort')
        return super.handleError(error);
    }

    let errorMsg = '';
    if(error && error.message){
      errorMsg = error.message;
    }

    if(errorMsg.indexOf('i18n/en.json') !== -1){
      return super.handleError(error); 
    }

    this.log.log(`AppErrorHandler error: ${JSON.stringify(error)}`);
    if(error && (error as any).status === 401){

    }
    else{
      if(window.location.href.indexOf('xncrs3.xnhotels.com/xms/wbe/dev') !== -1 || window.location.href.indexOf('localhost') !== -1){
        (window as any).lastError = error;
        if(error){
          let stack = [];
          if((error as any).stack){
            stack = (error as any).stack.split("\n").slice(0, 5);
          }
          let strMessage = `Error: ${error.message}.`;
          if((error as any).fileName){
            strMessage += `File ${(error as any).fileName}.`;
          }
          if(stack.length > 0){
            strMessage += `Trace ${stack.join("\n")}.`
          }
          this.messageService.add({severity:'error', summary: `Error`, detail: strMessage, key: 'toast', closable: true, life: 60000});
        }
        else{
          this.translate.get('common.error.general').subscribe(value => {
            this.messageService.add({severity:'error', summary: `Error`, detail: value, key: 'toast'});
          });
        }
      }
      else{
        this.translate.get('common.error.general').subscribe(value => {
          this.messageService.add({severity:'error', summary: `Error`, detail: value, key: 'toast'});
        });
      }
    }

    super.handleError(error);
  }

}
